<div class="box-emergencia">
    <div class="wrapper">
        <div class="left">
            <h2>
                Si tienes una<br/> emergencia llámanos.
            </h2>
            <p>
                Desde celulares al 22337 8000
            </p>
            <p>
                Desde teléfono fijo al 600 337 8000
            </p>
        </div>
        <div class="right">
            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
                <div ngxSlickItem *ngFor="let slide of slides" class="slide imagen-emergencia">
                    <img src="{{ slide.img }}" alt="" width="">
                    <!-- <div class="wrapper">
            <div class="left">
              <h1>
                Bienvenidos al Centro de Ayuda<br/>
                de Metrogas
              </h1>
              <h3>
                Todo lo que necesitas en<br/>
                un solo sitio.
              </h3>
            </div>
            <div class="right">
              right?
            </div>
        </div> -->
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</div>